import { useState, useEffect } from 'react';
import API from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { toast } from 'sonner';

const FIELDS = [
  { key: 'hot_months', label: 'Hot = bought in the last', unit: 'months' },
  { key: 'active_min_buys', label: 'Most Active = at least', unit: 'buys' },
  { key: 'active_months', label: '...within the last', unit: 'months' },
  { key: 'cold_months', label: 'Cold = no buys in the last', unit: 'months' },
];

export function GroupSettingsDialog({ open, onOpenChange, settings, onSaved }) {
  const [form, setForm] = useState(settings);
  useEffect(() => { if (open) setForm(settings); }, [open, settings]);

  const save = async () => {
    try {
      await API.put('/buyer-intel/settings', form);
      toast.success('Group rules saved'); onOpenChange(false); onSaved();
    } catch { toast.error('Failed to save'); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white max-w-sm" data-testid="group-settings-dialog">
        <DialogHeader><DialogTitle>Buyer Group Rules</DialogTitle></DialogHeader>
        <div className="space-y-3">
          {FIELDS.map(f => (
            <div key={f.key} className="flex items-center gap-2 text-sm text-gray-700">
              <span className="flex-1">{f.label}</span>
              <Input data-testid={`setting-${f.key}`} type="number" min={1} value={form?.[f.key] ?? ''} onChange={e => setForm(p => ({ ...p, [f.key]: parseInt(e.target.value) || 1 }))} className="w-20 bg-white border-gray-300" />
              <span className="w-14 text-gray-400">{f.unit}</span>
            </div>
          ))}
        </div>
        <Button data-testid="save-group-settings" onClick={save} className="w-full bg-[#0073ea] hover:bg-[#0060c2] text-white">Save Rules</Button>
      </DialogContent>
    </Dialog>
  );
}

export function TagDialog({ open, onOpenChange, buyerIds, onSaved }) {
  const [tag, setTag] = useState('');
  const apply = async (mode) => {
    if (!tag.trim()) return;
    try {
      await API.put('/buyer-intel/tags', { buyer_ids: buyerIds, [mode]: [tag.trim()] });
      toast.success(mode === 'add' ? 'Tag added' : 'Tag removed'); setTag(''); onOpenChange(false); onSaved();
    } catch { toast.error('Failed to update tags'); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white max-w-sm" data-testid="tag-dialog">
        <DialogHeader><DialogTitle>Tag {buyerIds.length} Buyer{buyerIds.length !== 1 ? 's' : ''}</DialogTitle></DialogHeader>
        <Input data-testid="tag-input" value={tag} onChange={e => setTag(e.target.value)} placeholder="e.g. VIP, Cash, Flipper" className="bg-white border-gray-300" onKeyDown={e => e.key === 'Enter' && apply('add')} />
        <div className="flex gap-2">
          <Button data-testid="tag-add-btn" onClick={() => apply('add')} className="flex-1 bg-[#0073ea] hover:bg-[#0060c2] text-white">Add Tag</Button>
          <Button data-testid="tag-remove-btn" variant="outline" onClick={() => apply('remove')} className="flex-1">Remove Tag</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
